import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Theme,
  Switch,
  CircularProgress,
  FormControlLabel,
  Popover,
  Checkbox,
  Divider,
  TextField,
  InputAdornment
} from "@material-ui/core";
import {
  AddIconTwo,
  DeleteIcon,
  EditIconTwo,
  CopyIcon2,
  ViewIcon,
  ReportHistoryIcon2,
  DeviceIcon2,
  TroubleShoot,
  CloseIconColor,
  Arrow
} from '../../components/Icons';
import { FilterList, Search } from '@material-ui/icons';
import { makeStyles } from "@material-ui/core/styles";
import { environment } from "../../environments/environment";
import Cookies from "js-cookie";
import useStyles from '../maintenance/assets/styles';
import { SearchBar } from 'src/components/sub-components/SearchBar';
import { Device } from '../models';
import { Pagination } from '@material-ui/lab';
import { DeviceForm } from './DeviceForm';
import { AuthService } from '../authentication/auth.service';
import { ToasterComponent } from '../maintenance/test-automation/components/Toaster';
import { connectDeviceWithCodecInDevices, getAllBatches, getAllCodecs, getAllDevices, getDevicesPaginated, getAllProducts, getDeviceById, getDeviceSummary, getFavorites, getMetaData } from '../testing-automation/api-helper/apiHelper';import {Link,useHistory} from 'react-router-dom';
import {AddnewProductVersion} from '../maintenance/otamanager/AddnewProductVersion';
import { DialogPopup } from '../maintenance/test-automation/components/DialogPopup';

export function DeviceComponent() {
  const classes = localStyles();
  const style = useStyles();
  const history = useHistory() 
  const [searchTerm, setSearchTerm] = useState('');
  const [filterValidity, setFilterValidity] = useState('All');
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [tempSelectedBatches, setTempSelectedBatches] = useState([]);
  const [tempFilterValidity, setTempFilterValidity] = useState('All');
  const [batchSearchTerm, setBatchSearchTerm] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [statusToggleDialogOpen, setStatusToggleDialogOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("none");

  const [isCloning, setIsCloning] = useState(false);
  const [formType, setFormType] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isToasterOpen, setIsToasterOpen] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [reqSuccess, setReqSuccess] = useState(false);

  const [allDevices, setAllDevices] = useState([]);
  const [allDevicesNotSorted, setAllDevicesNotSorted] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [deviceSummary, setDeviceSummary] = useState([]);
  const [sensors, setSensors] = useState([]);
  const [kitTypes, setKitTypes] = useState([]);
  const [actuators, setActuators] = useState([]);
  const [batchNumbers, setBatchNumbers] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [codecId, setCodecId] = useState("");
  const [codecs, setCodecs] = useState([]);
  const [isAddPopupOpen, setIsAddPopupOpen] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState('');

  const [totalElements, setTotalElements] = useState(0);

   const [formData, setFormData] = useState({
      id: '',
      name: '',
      interval: '',
      persistence: false,
      protocol: '',
      connectivity: 'GSM',
      batchNumber: '',
      simNumber: '',
      sensorCodes: [],
      actuatorCodes: [],
      productType: '',
      productId:'',
      productVersion:'',
      deviceParameterConfiguration:{},
      deviceModel: '',
      location: ''
    });

  const [errors, setErrors] = useState({
    id: null,
    name: null,
    interval: null,
    persistence: null,
    protocol: null,
    connectivity: null,
    batchNumber: null,
    sensorCodes: null,
    actuatorCodes: null,
    productType: null,
    productVersion: null,
    deviceModel: null,
    location: null
  });

    const [selectedProductTypeDetails, setSelectedProductTypeDetails] = useState(null);
    const [availableVersions,setAvailableVersions]=useState([]); //need to filter (N/A) 0.0.0 verison

  useEffect(() => {
  }, []);

  const initialDataFetch = async (targetPage = page - 1) => {
    setLoadingScreen(true);
    try {
      await Promise.all([
        fetchFavorites(),
        fetchDeviceSummary(),
        fetchDevices(targetPage, rowsPerPage),
        fetchMetaData(),
        fetchBatchNumbers(),
        fetchProducts(),
        fetchCodecs()
      ]);
    } catch (error) {
      console.error("Error in initial data fetch:", error);
    } finally {
      setLoadingScreen(false);
    }
  };

  useEffect(() => {
    initialDataFetch(0);
  }, []);

  const isFirstMount = useRef(true);

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      return;
    }
    setPage(1);
    fetchDevices(0, rowsPerPage, searchTerm, filterValidity, selectedBatches, sortOrder);
  }, [searchTerm, rowsPerPage, filterValidity, selectedBatches, sortOrder]);

  const historyPush = (path) => {
    window.location.href = path;
  }

  const fetchCodecs = async () => {
    try {
      const data = await getAllCodecs();
      setCodecs(data || []);
    } catch (error) {
      console.error("Error fetching codecs:", error);
    }
  };

  const fetchFavorites = async () => {
    try {
      const data = await getFavorites();
      setFavorites(data || []);

    } catch (error) {
      console.error('Error fetching favorites:', error);
    }
  }

  const fetchDeviceSummary = async () => {
    try {
      const data = await getDeviceSummary();
      setDeviceSummary(data || []);

    } catch (error) {
      console.error('Error fetching device summary:', error);
    }
  }

  const fetchDevices = async (
    pageIndex = page - 1,
    pageSize = rowsPerPage,
    searchTermVal = searchTerm,
    validityVal = filterValidity,
    batchesVal = selectedBatches,
    sortOrderVal = sortOrder
  ) => {
    try {
      const data = await getDevicesPaginated(
        pageIndex,
        pageSize,
        searchTermVal,
        validityVal,
        'LIST',
        batchesVal,
        'lastSeen',
        sortOrderVal
      );
      if (data) {
        setAllDevices(data.content || []);
        setAllDevicesNotSorted(data.content || []);
        setTotalElements(data.totalElements || 0);
      }
    } catch (error) {
      console.error('Error fetching devices:', error);
    }
  }

  const fetchMetaData = async () => {
    try {
      const data = await getMetaData();
      setSensors(data.sensors);
      setKitTypes(data.kitTypes);
      setActuators(data.actuators);

    } catch (error) {
      console.error('Error fetching meta data:', error);
    }
  }

  const fetchBatchNumbers = async () => {
    try {
      const data = await getAllBatches();
      setBatchNumbers(data || []);
    } catch (error) {
      console.error('Error fetching batch number:', error);
    }
  }

  const fetchProducts = async () => {
    try {
      const data = await getAllProducts('DETAIL');
      setAllProducts(data || []);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  }

  const handleFilterClick = (event) => {
    setTempSelectedBatches([...selectedBatches]);
    setTempFilterValidity(filterValidity);
    setBatchSearchTerm('');
    setAnchorEl(event.currentTarget);
  };
  const handleFilterClose = () => {
    setAnchorEl(null);
  };
  const handleFilterCancel = () => {
    setTempSelectedBatches([...selectedBatches]);
    setTempFilterValidity(filterValidity);
    setAnchorEl(null);
  };
  const handleApplyFilter = () => {
    setSelectedBatches(tempSelectedBatches);
    setFilterValidity(tempFilterValidity);
    setAnchorEl(null);
  };
  const handleToggleBatch = (batch) => {
    setTempSelectedBatches((prev) =>
      prev.includes(batch)
        ? prev.filter((b) => b !== batch)
        : [...prev, batch]
    );
  };
  const handleToggleValidity = (val) => {
    setTempFilterValidity((prev) => (prev === val ? 'All' : val));
  };

  const handleDeletePopupClose = () => {
    setSelectedDevice(null);
    setDeleteDialogOpen(false);
  }

  const handleDelete = async (device) => {
    try {
      const response = await fetch(
        `${environment.host}/core/device/${device.id}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      setAllDevices((prevDevices) => prevDevices.filter((d) => d.id !== device.id));
      setIsToasterOpen(true);
      setToasterMessage("Device Deleted Successfully");
      setReqSuccess(true);

    } catch (error) {
      setIsToasterOpen(true);
      setToasterMessage(error.response.data.message);
      setReqSuccess(false);
    } finally {
      setSelectedDevice(null);
      setDeleteDialogOpen(false);
      setTimeout(() => {
        setIsToasterOpen(false);
        setLoadingScreen(false);
      }, 4000);
    }
  };

  const toggleDeviceMode = async (device) => {
    const newStatus = device.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';

    try {
      setLoadingScreen(true);

      const response = await fetch(
        `${environment.host}/core/device/${device.id}/mode`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
          },
          body: newStatus,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      setAllDevices((prevDevices) =>
        prevDevices.map((d) =>
          d.id === device.id ? { ...d, status: newStatus } : d
        )
      );

      setIsToasterOpen(true);
      setToasterMessage(`Device status changed to ${newStatus}`);
      setReqSuccess(true);

    } catch (error) {
      setIsToasterOpen(true);
      setToasterMessage(error.response.data.message || error.message || 'Error toggling device status');
      setReqSuccess(false);

    } finally {
      setSelectedDevice(null);
      setStatusToggleDialogOpen(false);
      setTimeout(() => {
        setIsToasterOpen(false);
        setLoadingScreen(false);
      }, 4000);
    }
  };

  const getDevicesFiltered = () => {
    return allDevices || [];
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrentPage(newPage); // Ensure both variables are updated
    fetchDevices(newPage - 1, rowsPerPage, searchTerm, filterValidity, selectedBatches, sortOrder);
  };

  const sort = (colName) => {
    let nextSortOrder = sortOrder === 'asc' ? 'desc' : sortOrder === 'desc' ? 'none' : 'asc';
    setSortOrder(nextSortOrder);

    if (nextSortOrder === 'none') {
      setAllDevices([...allDevicesNotSorted]);
    } else {
      const sortedDevices = [...allDevices].sort((a, b) => {
        const valA = a[colName] ? new Date(a[colName]).getTime() : 0;
        const valB = b[colName] ? new Date(b[colName]).getTime() : 0;
        if (!valA && !valB) return 0;
        if (!valA) return 1;
        if (!valB) return -1;

        const multiplier = nextSortOrder === 'desc' ? -1 : 1;
        return (valA > valB ? 1 : valA < valB ? -1 : 0) * multiplier;
      });
      setAllDevices(sortedDevices);
    }
  };

  const getIcon = () => {
    if (sortOrder === 'asc') {
      return '&#9650;'; // ▲
    } else if (sortOrder === 'desc') {
      return '&#9660;'; // ▼
    }
    return '';
  };

  const handleClose = () => {
    setModalOpen(false);
    setSelectedDevice(null);
    setErrors({
      id: null,
      name: null,
      interval: null,
      persistence: null,
      protocol: null,
      connectivity: null,
      batchNumber: null,
      sensorCodes: null,
      actuatorCodes: null,
      productType: null,
      productVersion: null,
      deviceModel: null,
      location: null
    })
    setFormData({
      id: '',
      name: '',
      interval: '',
      persistence: false,
      protocol: '',
      connectivity: 'GSM',
      batchNumber: '',
      simNumber: '',
      sensorCodes: [],
      actuatorCodes: [],
      productType: '',
      productId:'',
      productVersion:'',
      deviceParameterConfiguration:{},
      deviceModel: '',
      location: ''
    })
  };

  const handleCloseVersion = () => {
    setIsAddPopupOpen(false);
  }

   const handleAddVersion=(version)=>{
    const alreadyExists = selectedProductTypeDetails.versions.some(
      (v) => v.versionNum === version.versionNum
    );

    if (alreadyExists) {
      console.warn('Version already exists:', version.versionNum);
      return;
    }
    let versionAdded=[...selectedProductTypeDetails.versions,version];
    let productDetailedUpdated={...selectedProductTypeDetails,versions:versionAdded};
    setSelectedProductTypeDetails(productDetailedUpdated);
    const updatedList = allProducts.map(item =>
      item.productName === productDetailedUpdated.productName ? productDetailedUpdated : item
    );
    setAllProducts(updatedList);
    const  availableVersionsAdded=[...availableVersions,version] //ensure 0.0.0 not inclueded 
    setAvailableVersions(availableVersionsAdded);
    setSelectedVersion(version.versionNum);

    
    let deviceParameterConfiguration = {};
    console.log(selectedProductTypeDetails);

    console.log('selectedVersionDetails',version["remoteConfigurations"],version["versionNum"])
    if(version&&version["remoteConfigurations"]&&version["versionNum"]){
      deviceParameterConfiguration["device"]=formData.name;
      deviceParameterConfiguration["versionNum"]=version["versionNum"];
      deviceParameterConfiguration["productType"]=formData.productType;
      deviceParameterConfiguration["remoteConfigurations"]=updateRemoteConfigurations(formData.name,version["remoteConfigurations"])

    setFormData({
      ...formData,
      productVersion:version.versionNum,
      deviceParameterConfiguration:deviceParameterConfiguration
      })
      setErrors((prev) =>({
        ...prev,
        productVersion:null
      }))
    }
    else {
      console.log('Invalid selectedVersionDetails or missing required properties.');
    }
  }

  const updateRemoteConfigurations = (deviceName,remoteConfigurations) => {

    // Regular expression to match any text inside curly braces
    const regex = /{([^}]+)}/g;
  
    let updatedRemoteConfigurations = remoteConfigurations.map(config => {
      if (regex.test(config.defaultValue)) {
        return {
          ...config,
          defaultValue: config.defaultValue.replace(regex, deviceName)
        };
      }
      return config;
    });
   return updatedRemoteConfigurations;
  };

  const handleDeviceSave = async (deviceData, type) => {
    setLoadingScreen(true);

    const userId = Cookies.get("USER_ID");
    const token = Cookies.get("ACCESS_TOKEN");

    const url =
      type === "EDIT"
        ? `${environment.host}/core/user/${userId}/device/${deviceData.id}`
        : `${environment.host}/core/user/${userId}/device`;

    const method = type === "EDIT" ? "PUT" : "POST";

    try {
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(deviceData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      connectDeviceWithCodecInDevices(codecId, deviceData.id)
      setCodecId("");
      setIsToasterOpen(true);
      setToasterMessage("Device " + (formType === "EDIT" ? "Updated" : "Created") + " Successfully");
      setReqSuccess(true);

    } catch (error) {
      setIsToasterOpen(true);
      setToasterMessage(error.response.data.message);
      setReqSuccess(false);
    } finally {
      setSelectedDevice(null)
      setTimeout(() => {
        setIsToasterOpen(false);
        setLoadingScreen(false);
      }, 4000);
      const nextPage = formType === "EDIT" ? page - 1 : 0;
      if (formType !== "EDIT") {
        setPage(1);
        setCurrentPage(1);
      }
      initialDataFetch(nextPage);
    }
  };

  const handleSubmit = (deviceData) => {
    if (!AuthService.isSuperAdmin() && !AuthService.hasNewUserAccess) {
      return;
    }
    if (formType === "EDIT") {
      handleDeviceSave(deviceData, "EDIT");
    } else {
      handleDeviceSave(deviceData, "ADD");
    }
    console.log('Device submitted:', deviceData);
    handleClose();
  };

  const openDeviceForm = async (type: string, device?: any) => {
    setFormType(type);
    if (type === "EDIT" || type === "CLONE") {
      setLoadingScreen(true);
      try {
        const fullDevice = await getDeviceById(device.id);
        setSelectedDevice(fullDevice);
        setModalOpen(true);
      } catch (error) {
        console.error("Error fetching device details:", error);
      } finally {
        setLoadingScreen(false);
      }
    } else {
      setSelectedDevice(null);
      setModalOpen(true);
    }
  };

  const handleToggle = (device) => {
    setStatusToggleDialogOpen(true);
    setSelectedDevice(device)
  };

  const createExpectedMessageFormat = (data) => {
    if (data.lastDecodeData || data.lastRawActuatorData) {
      let recievedLastRawData = data.lastDecodeData ? data.lastDecodeData
        .split('|').pop()
        .replace(/;$/, '') : '';
      let lastActuatorData = data.lastRawActuatorData? data.lastRawActuatorData :'';
      let connectedSensor = data.sensorCodes || []
      let connectedActuator = data.actuatorCodes || []
      let expectedFormat
      let validity;
      let sensorFormat;
      let actuatorFormat;
      if (connectedSensor.length === 0 && connectedActuator.length === 0) {
        expectedFormat = 'There is no sensor or actuators connected.';
      } else {
        const sensorValue = Object.assign({}, recievedLastRawData.split(';'),lastActuatorData.split(';'));
        sensorFormat = connectedSensor
          .map(function (device, index) {
            const value = sensorValue.hasOwnProperty(device) ? (sensorValue as any)[device] : 0;
            return index + '-' + device + ':' + value;
          })
          .join(';');
        actuatorFormat = connectedActuator
          .map(function (device, index) {
            const value = sensorValue.hasOwnProperty(device) ? (sensorValue as any)[device] : 0;
            return index + '-' + device + ':' + value;
          })
          .join(';');
        expectedFormat = sensorFormat && actuatorFormat ? sensorFormat + '*' + actuatorFormat : sensorFormat + actuatorFormat;
      }
      validity = isSameSensorFormat(sensorFormat, recievedLastRawData) || isSameSensorFormat(actuatorFormat,lastActuatorData)
      return validity;
    } else {
      return false
    }

  }

  const isSameSensorFormat = (data1, data2) => {
    const getKeys = d => new Set(d.split(';').map(i => i.split(':')[0]));

    const k1 = getKeys(data1);
    const k2 = getKeys(data2);

    if (k1.size !== k2.size) return false;

    for (let key of k1) {
      if (!k2.has(key)) return false;
    }
    return true;
  };

  return (
    <div className={classes.root}>
      <div className="page-heading">
        Device Board 
      </div>
      <div className={`testing`}>
        <Grid container className={style.container}>
          <Grid container alignItems="center">
            <Grid style={{ textAlign: "left", width: "255px", margin: " 0 10px 0 0" }}>
              <SearchBar placeholder="Search Device" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            </Grid>

            <Grid item>
              <div
                className={`filerButton ${selectedBatches.length > 0 || filterValidity !== 'All' ? classes.filterButtonActive : ''}`}
                onClick={handleFilterClick}
              >
                <span className={classes.filterIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.6668 2H1.3335L6.66683 8.30667V12.6667L9.3335 14V8.30667L14.6668 2Z"
                      stroke={(selectedBatches.length > 0 || filterValidity !== 'All') ? "#2A7CED" : "#324054"}
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className={`${classes.filterButtonText} ${selectedBatches.length > 0 || filterValidity !== 'All' ? classes.filterButtonTextActive : ''}`}>
                  Filter
                </span>
                {(selectedBatches.length > 0 || filterValidity !== 'All') && (
                  <span className={classes.filterBadge}>
                    {selectedBatches.length + (filterValidity !== 'All' ? 1 : 0)}
                  </span>
                )}
              </div>
              <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleFilterClose}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                PaperProps={{
                  className: classes.filterPopover,
                }}
              >
                <div className={classes.filterHeader}>
                  <Typography className={classes.filterTitle}>Filter</Typography>
                </div>

                <div className={classes.filterBody}>
                  <Typography className={classes.filterSectionTitle}>Batch ID</Typography>
                  <TextField
                    fullWidth
                    placeholder="Search..."
                    variant="outlined"
                    size="small"
                    className={classes.filterSearchInput}
                    value={batchSearchTerm}
                    onChange={(e) => setBatchSearchTerm(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Search className={classes.filterSearchIcon} />
                        </InputAdornment>
                      ),
                    }}
                  />

                  <div className={classes.batchListContainer}>
                    {batchNumbers
                      .filter((batch) =>
                        batch ? batch.toLowerCase().includes(batchSearchTerm.toLowerCase()) : false
                      )
                      .map((batch, index) => (
                        <div
                          key={index}
                          className={classes.batchItem}
                          onClick={() => handleToggleBatch(batch)}
                        >
                          <Checkbox
                            className={classes.batchCheckbox}
                            size="small"
                            disableRipple
                            checked={tempSelectedBatches.includes(batch)}
                          />
                          <Typography className={classes.batchLabel}>{batch}</Typography>
                        </div>
                      ))}
                    {batchNumbers.filter((batch) =>
                      batch ? batch.toLowerCase().includes(batchSearchTerm.toLowerCase()) : false
                    ).length === 0 && (
                      <Typography className={classes.noBatchesText}>
                        No batches found
                      </Typography>
                    )}
                  </div>

                  <Typography className={classes.validitySectionTitle}>
                    Data Validity
                  </Typography>
                  <div className={classes.validityChipsContainer}>
                    <div
                      className={`${classes.validityChip} ${
                        tempFilterValidity === 'Valid' ? classes.validityChipActive : ''
                      }`}
                      onClick={() => handleToggleValidity('Valid')}
                    >
                      Valid
                    </div>
                    <div
                      className={`${classes.validityChip} ${
                        tempFilterValidity === 'Invalid' ? classes.validityChipActive : ''
                      }`}
                      onClick={() => handleToggleValidity('Invalid')}
                    >
                      Invalid
                    </div>
                  </div>

                  <Divider className={classes.filterDividerBottom} />

                  <div className={classes.filterActions}>
                    <Button className={classes.cancelBtn} onClick={handleFilterCancel}>
                      Cancel
                    </Button>
                    <Button className={classes.applyBtn} onClick={handleApplyFilter}>
                      Apply Filter
                    </Button>
                  </div>
                </div>
              </Popover>
            </Grid>
          </Grid>

          <Grid item xs={12} style={{ marginTop: "20px" }}>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableCell}>ID</TableCell>
                    <TableCell className={classes.tableCell}>Device Name</TableCell>
                    <TableCell className={classes.tableCell}>Data Validity</TableCell>
                    <TableCell className={classes.tableCell}>Reference</TableCell>
                    <TableCell className={`${classes.tableCell} ${classes.sortableHeaderCell}`} onClick={() => sort('lastSeen')}>
                      Last Seen
                      {sortOrder !== 'none' ? (
                        <span className={classes.sortIcon} dangerouslySetInnerHTML={{ __html: getIcon() }} />
                      ) : (
                        <img src="../../assets/images/sort-option.svg" alt="sort" className={classes.sortIcon} />
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell} style={{ textAlign: "center" }}>Mode</TableCell>
                    <TableCell className={classes.tableCell} style={{ textAlign: "center" }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getDevicesFiltered()
                    .map((device, index) => (
                      <TableRow
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#F5F5F5" : "white",
                        }}
                      >
                        <TableCell className={classes.tableCellBody}>{device.id}</TableCell>
                        <TableCell className={classes.tableCellBody}>{device.name}</TableCell>
                        <TableCell className={classes.tableCellBody}>
                          <label className={createExpectedMessageFormat(device) ? "enabled" : "disabled"}>
                            {createExpectedMessageFormat(device) ? 'Valid' : 'Invalid'}
                          </label>
                        </TableCell>
                        <TableCell className={classes.tableCellBody}>{device.referenceName}</TableCell>
                        <TableCell className={classes.tableCellBody}>{device.lastSeen}</TableCell>
                        <TableCell style={{ cursor: 'default' }} align="center">
                          <button
                            className={`${classes.activeInactiveBtn} ${device.status ? classes.active : classes.inactive
                              }`}
                          >
                            {device.status === "ACTIVE" ? 'ACTIVE' : 'INACTIVE'}
                          </button>
                        </TableCell>
                        <TableCell
                          className={classes.tableCellBody}
                          style={{
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Tooltip
                            title={
                              ((device.sensorCodes && device.sensorCodes.length) || 0) === 0
                                ? "No data available"
                                : "View"
                            }
                          >
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                disabled={((device.sensorCodes && device.sensorCodes.length) || 0) === 0}
                                onClick={() => historyPush(`/device/${device.id}`)}
                              >
                                <ViewIcon color={((device.sensorCodes && device.sensorCodes.length) || 0) === 0 ? "#B0B0B0" : "#707070"} />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip
                            title={
                              ((device.actuatorCodes && device.actuatorCodes.length) || 0) === 0
                                ? "No data available"
                                : "Actuator View"
                            }
                          >
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                disabled={((device.actuatorCodes && device.actuatorCodes.length) || 0) === 0}
                                onClick={() => historyPush(`/device/${device.id}/actuator`)}
                              >
                                <DeviceIcon2 color={((device.actuatorCodes && device.actuatorCodes.length) || 0) === 0 ? "#B0B0B0" : "#707070"} />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Maintenance">
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                onClick={() => historyPush(`/device/maintenance/${device.id}`)}
                              >
                                <ReportHistoryIcon2 />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Edit">
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                onClick={() => {
                                  openDeviceForm("EDIT", device);
                                }}
                              >
                                <EditIconTwo />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="TroubleShoot">
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                onClick={() => historyPush(`/device/${device.id}/troubleshoot`)}
                              >
                                <TroubleShoot />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Clone Device">
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                onClick={() => {
                                  setIsCloning(true);
                                  openDeviceForm("CLONE", device);
                                }}
                              >
                                <CopyIcon2 />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title={device.status === "ACTIVE" ? "IN-ACTIVATE" : "ACTIVATE"} placement="top">
                            <FormControlLabel
                              style={{
                                marginLeft: 0,
                                marginRight: 0,
                              }}
                              control={
                                <Switch
                                  checked={device.status === "ACTIVE"}
                                  onChange={(event) => {
                                    const newStatus = event.target.checked ? "ACTIVE" : "INACTIVE";
                                    console.log("New status:", newStatus);
                                    handleToggle(device);
                                  }}
                                  color="default"
                                  size="small"
                                />
                              }
                              label=""
                            />
                          </Tooltip>
                          <Tooltip title="Delete">
                            <span>
                              <IconButton
                                size="small"
                                style={{ padding: "4px" }}
                                onClick={() => {
                                  setSelectedDevice(device);
                                  setDeleteDialogOpen(true);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          {/* Pagination */}
          <Grid container justifyContent="center">
            {totalElements > rowsPerPage && (
              <Pagination
                className={style.pagination}
                page={page}
                onChange={handleChangePage}
                count={Math.ceil(totalElements / rowsPerPage)}
                shape="rounded"
                defaultPage={1}
              />
            )}
          </Grid>
        </Grid>

        {/* Delete Confirmation Dialog */}
        {selectedDevice && (
          <Dialog
            open={deleteDialogOpen}
            onClose={() => handleDeletePopupClose()}
            maxWidth="md"
            classes={{ paper: style.deletePopup }}
          >
            <Grid container className={style.deleteHeader}>
              <Grid item xs={10} md={10}>
                <DialogTitle>CONFIRMATION</DialogTitle>
              </Grid>
              <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                <IconButton onClick={handleDeletePopupClose} style={{ paddingTop: "20px" }}>
                  <CloseIconColor />
                </IconButton>
              </Grid>
            </Grid>

            <DialogContent className={style.deleteContent}>
              <Grid container>
                <Grid style={{ margin: "0" }}>
                  <Typography className={style.popupLabel} style={{ color: "#FF4343" }}>
                    Are you sure you want to delete this device {selectedDevice.name}?
                  </Typography>
                  <Typography className={style.popupLabel}>
                    The delete action will remove the device.
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>

            <div className={style.DeletePopupFooter}>
              <Button
                variant="contained"
                onClick={handleDeletePopupClose}
                className={style.popupCancel}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className={style.popupDelete}
                onClick={() => handleDelete(selectedDevice)}
                style={{ marginRight: "21px" }}
              >
                DELETE
              </Button>
            </div>
          </Dialog>
        )}

        {/* Toggle Status Confirmation Dialog */}
        {selectedDevice && (
          <Dialog
            open={statusToggleDialogOpen}
            onClose={() => setSelectedDevice(null)}
            maxWidth="md"
            classes={{ paper: style.deletePopup }}
          >
            <Grid container className={style.deleteHeader}>
              <Grid item xs={10} md={10}>
                <DialogTitle>CONFIRMATION</DialogTitle>
              </Grid>
              <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                <IconButton onClick={() => setSelectedDevice(null)} style={{ paddingTop: "20px" }}>
                  <CloseIconColor />
                </IconButton>
              </Grid>
            </Grid>

            <DialogContent className={style.deleteContent}>
              <Grid container>
                <Grid style={{ margin: "0" }}>
                  <Typography className={style.popupLabel} style={{ color: "#FF4343" }}>
                    Are you sure you want to Change the status of device {selectedDevice.name} from {selectedDevice.status}?
                  </Typography>
                  <Typography className={style.popupLabel}>
                    The status change action will update the status of the device.
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>

            <div className={style.DeletePopupFooter}>
              <Button
                variant="contained"
                onClick={() => setSelectedDevice(null)}
                className={style.popupCancel}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className={style.popupDelete}
                onClick={() => toggleDeviceMode(selectedDevice)}
                style={{ marginRight: "21px" }}
              >
                CHANGE
              </Button>
            </div>
          </Dialog>
        )}

      </div>

      {/* Add Device */}
      <div
        className="material-button-div"
        style={{ position: "fixed", bottom: 20, right: 20, zIndex: 1000 }}
      >
        <Button
          variant="contained"
          onClick={() => openDeviceForm("ADD")}
          style={{
            minWidth: "50px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#2A7CED",
            color: "#fff",
            boxShadow: "0 3px 6px rgba(0,0,0,0.275)",
            padding: 0,
          }}
        >
          <AddIconTwo color="#FFF" />
        </Button>
      </div>

      <ToasterComponent
        reqSuccess={reqSuccess}
        message={toasterMessage}
        toaster={isToasterOpen}
      />

      <DialogPopup
        open={isAddPopupOpen}
        onClose={handleCloseVersion}
        title="Add New Version"
        dialogContent={<AddnewProductVersion goBack={handleCloseVersion} addDevicePage={true} handleAddVersion={handleAddVersion} selectedProductType={selectedProductTypeDetails} />}
        buttonRequired={false}
        onSubmit={handleCloseVersion}
      />

      {/* Loading Screen */}
      {loadingScreen && (
        <div
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            backgroundColor: "#000000",
            opacity: 0.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            width: "100vw",
            height: "100vh",
          }}
        >
          <CircularProgress size={80} />
        </div>
      )}

      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100vh',
            width: '100vw',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 1000,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <DeviceForm
            onClose={handleClose}
            onSubmit={handleSubmit}
            allDevices={allDevices}
            selectedDevice={selectedDevice}
            isCloning={false}
            setCodecId={setCodecId}
            formType={formType}
            sensors={sensors}
            actuators={actuators}
            batches={batchNumbers}
            allProducts={allProducts}
            codecs={codecs}
            setLoading={setLoadingScreen}
            hasPermissionFor={() => true /* or your real permission check */}
            formData={formData}
            setFormData={setFormData}
            availableVersions={availableVersions}
            selectedProductTypeDetails={selectedProductTypeDetails}
            setSelectedProductTypeDetails={setSelectedProductTypeDetails}
            setIsAddPopupOpen={setIsAddPopupOpen}
            setAvailableVersions={setAvailableVersions}
            errors={errors}
            setErrors={setErrors}
          />
        </div>
      )}
    </div>
  );
}

const localStyles = makeStyles((theme: Theme) => ({
  root: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tableText: {
    fontSize: "14px",
    color: "#3C3C3C",
  },
  versionChip: {
    backgroundColor: "#e6edf7",
    color: "#2a7ced",
    height: "20px",
    border: `1px solid #2A7CED`,
  },
  deleteButton: {
    backgroundColor: "#F06A6A",
    color: "white",
    "&:hover": {
      backgroundColor: "#D9534F",
    },
  },
  tableCell: {
    textAlign: "left",
    borderBottomColor: "white",
    borderTopColor: "white",
    backgroundColor: "white",
  },
  tableCellBody: {
    textAlign: "left",
    borderBottomColor: "white",
    borderTopColor: "white",
  },
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0px 3px 6px #00000029",
  },
  statusListStyle: {
    float: "right",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    padding: "10px",
    marginRight: "0",
  },
  statusBadgeStyle: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    minWidth: "120px",
    border: "2px solid transparent",
  },
  approvedStyle: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    minWidth: "120px",
    border: "2px solid transparent",
    backgroundColor: "#d4f8d4",
    color: "#9cf79c",
    borderColor: "#9cf79c",
  },
  pendingStyle: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    minWidth: "120px",
    border: "2px solid transparent",
    backgroundColor: "#fde8cd",
    color: "#f8d394",
    borderColor: "#f8d394",
  },
  notApprovedStyle: {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: "8px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
    minWidth: "120px",
    border: "2px solid transparent",
    backgroundColor: "#f8d7da",
    color: "#f47c88",
    borderColor: "#f47c88",
  },
  imageBoxes: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  imageBox: {
    textAlign: "center",
    width: "28%",
    backgroundColor: "#eee",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5px",
    padding: "10px",
  },
  image: {
    width: "120px",
    height: "90px",
    margin: "20px",
  },
  imgText: {
    margin: "20px",
  },
  activeInactiveBtn: {
    border: "none",
    backgroundColor: "rgb(206, 251, 204)",
    color: "green",
    borderRadius: "20px",
    padding: "5px 10px",
    width: "90%",
    cursor: "default",
  },
  active: {
    background: "#DFF2EE 0% 0% no-repeat padding-box",
    color: "#02C170",
    opacity: 1,
  },
  inactive: {
    background: "#bab9b9 0% 0% no-repeat padding-box",
    color: "#646363",
    opacity: 1,
  },
  filterButtonActive: {
    backgroundColor: "#EBF3FB !important",
    borderColor: "#2A7CED !important",
    color: "#2A7CED !important",
  },
  filterIcon: {
    marginRight: "8px",
    display: "inline-flex",
    alignItems: "center",
  },
  filterButtonText: {
    color: "#324054",
    fontFamily: "inherit",
  },
  filterButtonTextActive: {
    color: "#2A7CED !important",
  },
  filterBadge: {
    marginLeft: "6px",
    backgroundColor: "#005088",
    color: "#ffffff",
    borderRadius: "10px",
    padding: "1px 6px",
    fontSize: "11px",
    fontWeight: "bold",
  },
  filterPopover: {
    padding: 0,
    width: "560px",
    borderRadius: "8px",
    border: "1px solid #E2E5ED",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
    marginLeft: "4px !important",
    overflow: "hidden",
    fontFamily: "Poppins, Roboto, sans-serif",
    textAlign: "left",
    "& *": {
      boxSizing: "border-box",
    },
    "& div": {
      margin: 0,
    },
  },
  filterHeader: {
    padding: "12px 20px",
    borderBottom: "1px solid #E2E5ED",
    backgroundColor: "#FFFFFF",
    margin: "0 !important",
    textAlign: "left",
  },
  filterTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#324054",
    margin: "0 !important",
    fontFamily: "inherit",
    textAlign: "left",
  },
  filterBody: {
    padding: "20px",
    margin: "0 !important",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    boxSizing: "border-box",
  },
  filterSectionTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#324054",
    fontFamily: "inherit",
    textAlign: "left",
    margin: "0 0 8px 0 !important",
  },
  validitySectionTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#324054",
    fontFamily: "inherit",
    textAlign: "left",
    margin: "16px 0 8px 0 !important",
  },
  filterSearchInput: {
    width: "100% !important",
    margin: "0 0 14px 0 !important",
    display: "block",
    "& .MuiOutlinedInput-root": {
      width: "100% !important",
      height: "38px",
      fontSize: "14px",
      borderRadius: "4px",
      backgroundColor: "#FFFFFF",
      margin: "0 !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E2E5ED",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#B0B8C7",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2A7CED",
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 12px",
      color: "#324054",
      fontFamily: "inherit",
      "&::placeholder": {
        color: "#868DAA",
        opacity: 1,
      },
    },
  },
  filterSearchIcon: {
    color: "#868DAA",
    fontSize: 18,
  },
  batchListContainer: {
    maxHeight: "160px",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "12px",
    paddingRight: "6px",
    margin: "0 !important",
    width: "100%",
    boxSizing: "border-box",
    "&::-webkit-scrollbar": {
      width: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#D9D9D9",
      borderRadius: "5px",
    },
  },
  batchItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    cursor: "pointer",
    userSelect: "none",
    margin: "0 !important",
    width: "100%",
    textAlign: "left",
  },
  batchCheckbox: {
    padding: "0 !important",
    margin: "0 8px 0 0 !important",
    color: "#868DAA",
    "&.Mui-checked": {
      color: "#005B96",
    },
    "& .MuiSvgIcon-root": {
      fontSize: 20,
    },
  },
  batchLabel: {
    fontSize: "14px",
    color: "#324054",
    fontFamily: "inherit",
    textAlign: "left",
    margin: "0 !important",
  },
  noBatchesText: {
    fontSize: "13px",
    color: "#868DAA",
    padding: "8px 0",
    fontFamily: "inherit",
    textAlign: "left",
    margin: "0 !important",
  },
  validityChipsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "12px",
    margin: "0 !important",
    width: "100%",
    textAlign: "left",
  },
  validityChip: {
    padding: "4px 12px",
    borderRadius: "100px",
    fontSize: "11px",
    fontWeight: 600,
    cursor: "pointer",
    border: "1px solid #959AB0",
    backgroundColor: "#FEFEFE",
    color: "#959AB0",
    transition: "all 0.2s ease",
    userSelect: "none",
    fontFamily: "inherit",
    margin: "0 12px 0 0 !important",
    flex: "0 0 auto",
  },
  validityChipActive: {
    border: "1px solid #2A7BEC",
    backgroundColor: "#DDE9FA",
    color: "#2A7BEC",
  },
  filterDividerBottom: {
    margin: "16px 0 !important",
    backgroundColor: "#CDCFD1",
    width: "100%",
  },
  filterActions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    paddingTop: "4px",
    margin: "0 !important",
    width: "100%",
  },
  cancelBtn: {
    border: "1px solid #C4C2C2",
    borderRadius: "4px",
    color: "#C4C2C2",
    backgroundColor: "#FFFFFF",
    textTransform: "none",
    fontWeight: 400,
    fontSize: "15px",
    height: "44px",
    minWidth: "130px",
    fontFamily: "inherit",
    margin: "0 !important",
    "&:hover": {
      backgroundColor: "#F9FAFB",
      borderColor: "#98A2B3",
      color: "#646363",
    },
  },
  applyBtn: {
    backgroundColor: "#005B96",
    borderRadius: "4px",
    color: "#FFFFFF",
    textTransform: "none",
    fontWeight: 400,
    fontSize: "15px",
    height: "44px",
    minWidth: "150px",
    fontFamily: "inherit",
    margin: "0 !important",
    "&:hover": {
      backgroundColor: "#004B7C",
    },
  },
  sortableHeaderCell: {
    cursor: "pointer",
    userSelect: "none",
  },
  sortIcon: {
    marginLeft: 4,
  },
}));
